import PropTypes from 'prop-types';
import React from 'react';

import { TeamIcon } from 'common/react/components/TeamIcon';
import { TeamWatermarkBackground } from 'widgets/statspro/js/components/TeamWatermarkBackground';
import { useSingleSiteSetting } from 'common/react/hooks/use-single-site-setting';
import { SvgIcon } from 'common/react/components/SvgIcon';

export const TLCondensedHeaderSingle = ({ matchRoster, match }) => {
    const {
        awayTeam,
        homeTeam,
        matchUrl,
        venueLandOwner,
        venueLocation,
        venueName
    } = match;

    const homeTeamId = matchRoster.homeTeam.teamId,
        awayTeamId = matchRoster.awayTeam.teamId,
        name = `${homeTeam} v ${awayTeam}`,
        selectedRegion = useSingleSiteSetting('region'),
        startTime = moment(match.startTime);

    const onClick = () => {
        const url = new URL(match.matchUrl, location.origin);

        /* eslint-disable camelcase */
        PULSE.app.tracking.recordEvent(
            PULSE.app.common.CONSTANTS.TRACKING.EVENTS.SELECT.LINK,
            {
                eventData: {
                    link_text: `${name}`,
                    link_url: match.matchUrl,
                    outbound: url.origin !== location.origin,
                    type:
                        url.origin !== location.origin
                            ? 'external'
                            : 'internal',
                    component_name: 'condensed team lineups',
                    component_content_type:
                        PULSE.app.common.CONSTANTS.TRACKING.CONTENT_TYPES
                            .LINEUPS
                }
            }
        );
        /* eslint-enable camelcase */
    };

    return (
        <a className="team-lineups-header" href={matchUrl} onClick={onClick}>
            <TeamWatermarkBackground
                className="team-lineups-header__watermark team-lineups-header__watermark--home"
                providerId={homeTeamId}
                side="left"
            />
            <TeamWatermarkBackground
                className="team-lineups-header__watermark team-lineups-header__watermark--away"
                providerId={awayTeamId}
            />
            <div className="team-lineups-header__details u-hide-from-tablet">
                <p>Mobile</p>
                <span className="team-lineups-header__name">
                    {name.split(' ').slice(0, -1).join(' ')}{' '}
                    <span style={{ whiteSpace: 'nowrap' }}>
                        {name.split(' ').pop()}
                        <SvgIcon icon="arrow-right" className="icon" />
                    </span>
                </span>
            </div>
            <div className="team-lineups-header__content">
                <div className="team-lineups-header__logo-wrapper">
                    <TeamIcon
                        providerId={homeTeamId}
                        className="team-lineups-header__logo"
                        theme="light"
                    />
                </div>
                <div className="team-lineups-header__details">
                    <span className="team-lineups-header__name u-hide-until-tablet">
                        <p>Desktop</p>
                        {name.split(' ').slice(0, -1).join(' ')}{' '}
                        <span style={{ whiteSpace: 'nowrap' }}>
                            {name.split(' ').pop()}
                            <SvgIcon icon="arrow-right" className="icon" />
                        </span>
                    </span>
                    <div className="team-lineups-header__info">
                        <span>
                            {startTime
                                .tz(selectedRegion.timezone)
                                .format(
                                    PULSE.app.common.CONSTANTS.MATCH_TIME_FORMAT
                                )}
                            {startTime.tz(selectedRegion.timezone).format('a')}
                        </span>
                        {'\uFF65'}
                        <span>
                            {venueName}, {venueLocation}
                        </span>
                        {'\uFF65'}
                        <span>{venueLandOwner}</span>
                    </div>
                </div>
                <div className="team-lineups-header__logo-wrapper">
                    <TeamIcon
                        providerId={awayTeamId}
                        className="team-lineups-header__logo"
                        theme="light"
                    />
                </div>
            </div>
        </a>
    );
};

TLCondensedHeaderSingle.propTypes = {
    match: PropTypes.object.isRequired,
    matchRoster: PropTypes.object.isRequired,
    teamDisplay: PropTypes.string.isRequired
};
